export const LEAD_FORM_SENT_ID = "sent_form_id";
export const GOROSKOP_LEAD_FORM_SENT_ID = "sent_goroskop_form_id";